import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";
import MySwitch from "src/components/MySwitch/MySwitch";
import { useDarkModeData } from "src/context/DarkModeContext";

export default function GlobalDrawer_DarkModeListItem() {
  const { darkMode, doSetDarkMode: setDarkMode } = useDarkModeData();
  const onClick = () => setDarkMode(!darkMode);

  return (
    <ListItem disablePadding dense>
      <ListItemButton onClick={onClick}>
        <ListItemIcon>
          <MySwitch checked={darkMode} />
        </ListItemIcon>
        <ListItemText primary="Darkmode" />
      </ListItemButton>
    </ListItem>
  );
}

GlobalDrawer_DarkModeListItem.propTypes = {
  fontSize: PropTypes.string,
};
